import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import Title from './qanda-components/title';
import Details from './qanda-components/details';
import { TenTwentyFourCollapseSectionContainer } from './styles';
import useGetQandasByFund from '../../../services/funds/qanda-service';
import { scrollIfHashMatch } from '../navigation/utils';
import useNavigationStateStore from '../navigation/navigation-state-hook';

const Container = styled(TenTwentyFourCollapseSectionContainer)`
  padding-bottom: 0 !important; /* for bottom stickout */
  margin-bottom: 120px;

  ${props => props.theme.isMobileOrTablet && `
    padding-top: 56px;
  `};
`;

const sectionName = 'q-and-a';

export default function Qanda(props) {
  const { fund } = props;
  const [{ data }, getQandas] = useGetQandasByFund();
  const [qandas, setQandas] = React.useState([]);
  const set = useNavigationStateStore(state => state.set);

  useChangeAwareEffect(({ isMount }) => {
    isMount && scrollIfHashMatch(sectionName);
  }, {});

  React.useEffect(() => {
    _.get(fund, 'id') && getQandas(fund.id);
  }, [fund, getQandas]);

  React.useEffect(() => {
    if (_.get(data, 'qandas.length')) {
      const withAnswer = data.qandas.filter(q => _.trim(_.get(q, 'answer')).length);
      setQandas(withAnswer);
      set(state => {
        state.hasQandA = withAnswer.length > 0;
      });
    }
  }, [data, set]);

  if (qandas.length === 0) {
    return null;
  }

  const detailsProps = {
    qandas, fund,
  };

  return (
    <Container name={sectionName}>
      <Title {...props} />
      <Details {...detailsProps} />
    </Container>
  );
}

Qanda.propTypes = {
  fund: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    qandasUpdatedAt: PropTypes.string,
  }).isRequired,
  manager: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    profilePictureUrl: PropTypes.string.isRequired,
    position: PropTypes.string,
  }).isRequired,
  livewireLogo: PropTypes.string.isRequired,
};
